import { defineComponent as t, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as c, renderSlot as l, createElementVNode as s } from "vue";
import i from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ s("path", {
  role: "presentation",
  d: "M12 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm6.762 7a7.073 7.073 0 00-13.524 0h13.524zM4 21a1 1 0 01-1-1h-.008a9.08 9.08 0 01.02-.159 9.08 9.08 0 015.454-7.127 5.5 5.5 0 117.068 0A9.08 9.08 0 0121.008 20H21a1 1 0 01-1 1H4z"
}, null, -1), _ = /* @__PURE__ */ t({
  name: "AccountProfile",
  __name: "account-profile",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (o, d) => (r(), a(i, n(p(e.props)), {
      default: c(() => [l(o.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
